module.exports = __webpack_public_path__ + "img/btn_instar_wing.e8909a17.png";